module.exports = __webpack_public_path__ + "static/logo-monochrome-517b8bd9c4a37fb8d6e58b299a7f32a9.png";